import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorPaquetePPCobranza } from "./paquetespp";

import { setEquals } from "keautils";

interface Props {
    sugerencia: models.ContrareciboSugeridoModel;
    /**Folios de las guias seleccionadas */
    paquetespp: number[];
    onSeleccionar: (x: number[]) => void;
}

/**Selecciona un conjunto de guias agrupadas por cliente */
export class PaquetesPPPorClienteComp extends React.PureComponent<Props> {
    onTodas = () => {
        this.props.onSeleccionar(this.props.sugerencia.Paquetes.map(x => x.IdPaquetePP));
    }
    onNinguna = () => {
        this.props.onSeleccionar([]);
    }

    render() {
        const ningunaPaquete = this.props.paquetespp.length == 0;
        const todasGuias = setEquals(this.props.sugerencia.Paquetes.map(x => x.IdPaquetePP), this.props.paquetespp);
        return (
            <kea.Panel
                title={this.props.sugerencia.NombreCliente}
                iconClass={fa("user")}
                buttons={[
                    <kea.Button onClick={this.onTodas} style={todasGuias ? "info" : "default"} iconClass={fa("check-square-o")} />,
                    <kea.Button onClick={this.onNinguna} style={ningunaPaquete ? "info" : "default"} iconClass={fa("square-o")} />
                ]}>
                <span>
                    <label>
                        Sucursal de cobranza:
                    </label>
                    {this.props.sugerencia.NombreSucursalCobranza}
                    <MultiselectorPaquetePPCobranza items={this.props.sugerencia.Paquetes} value={this.props.paquetespp} onChange={this.props.onSeleccionar} hideBusqueda />
                </span>
            </kea.Panel>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibospp/clientecomp.tsx